import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Smartphone, Eye, RefreshCw } from 'lucide-react';
const painPoints = [{
  title: 'Ansiedad digital',
  description: 'Revisar el teléfono obsesivamente esperando un mensaje que no llega o que no dice lo que esperas.',
  icon: Smartphone
}, {
  title: 'Visto que duele',
  description: 'La tortura psicológica de ser ignorada, dejada en visto, y la pérdida de poder que eso conlleva.',
  icon: Eye
}, {
  title: 'Ciclo de humillación',
  description: 'Romper el contacto cero, rogar por atención y sentir la vergüenza inmediata al presionar enviar.',
  icon: RefreshCw
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: 'easeOut'
    }
  }
};
export function PainSection() {
  return <section className="py-32 px-6 bg-charcoal relative border-t border-gold/10" data-id="element-112">
      <div className="max-w-6xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20" data-id="element-114">
          <h2 className="font-playfair text-4xl md:text-5xl text-white mb-6" data-id="element-115">
            El Secuestro de la{' '}
            <span className="text-gold italic" data-id="element-116">Dopamina</span>
          </h2>
          <div className="w-24 h-[1px] bg-gold mx-auto opacity-50" data-id="element-117" />
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-118">
          {painPoints.map((point, index) => <motion.div key={index} variants={itemVariants} className="bg-card p-10 rounded-sm border border-white/5 hover:border-gold/30 transition-colors duration-500 group relative overflow-hidden" data-id="element-119">
              {/* Subtle hover gradient */}
              <div className="absolute inset-0 bg-gradient-to-b from-gold/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-120" />

              <div className="relative z-10" data-id="element-121">
                <div className="w-14 h-14 rounded-full bg-charcoal border border-gold/20 flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-500" data-id="element-122">
                  <point.icon className="w-6 h-6 text-gold" strokeWidth={1.5} data-id="element-123" />
                </div>
                <h3 className="font-playfair text-2xl text-white mb-4" data-id="element-124">
                  {point.title}
                </h3>
                <p className="font-sans text-gray-400 leading-relaxed font-light" data-id="element-125">
                  {point.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}